/**
 * Capitalize a string
 * @param {*} string
 * @returns {string}
 */
export default function capitalize(string) {
  return string
    ? `${string.substring(0, 1).toUpperCase()}${string.substring(1).toLowerCase()}`
    : '';
}
